export const ACCESS_TOKEN_NAME = "tenzu_admin_access";
export const REFRESH_TOKEN_NAME = "tenzu_admin_refresh";
